import { Component } from '@angular/core';
import { Router } from '@angular/router';

export interface Link {
  path: string;
  title: string;
}
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  showMenu = false;
  init = false;

  links: Link[] = [{
    path: '/about',
    title: 'About Us',
  },
  {
    path: '/menu',
    title: 'Menu',
  },
  {
    path: '/gallery',
    title: 'Gallery',
  },
  {
    path: '/contact',
    title: 'Contact',
  }
];
  constructor(private route: Router) { }
  isActiveRoute(url:string):boolean {
    let path = this.route.url.substring(1);
    let splitPath = path.split('/');

    if(splitPath[0] === url.substring(1))
      return true;
    else
      return false;
  }
  toggleMenu() {
    this.init = true;
    if(this.showMenu)
      this.showMenu = false;
    else
      this.showMenu = true;
  }
}
